import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@/lib/utils';
import { UserPreferencesRepository } from '@/features/pages/repositories/UserPreferencesRepository';

let SUBDOMAIN_FOR_LOCAL_DEV = '';

export const useSubdomainValidation = () => {
  const subdomain = getSubdomain() || SUBDOMAIN_FOR_LOCAL_DEV;
  SUBDOMAIN_FOR_LOCAL_DEV = subdomain;

  // Only make the query if we're actually on a subdomain
  const shouldQuery = !!subdomain;

  const {
    data: displayName,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['subdomain-validation', subdomain],
    queryFn: async () => {
      if (!subdomain) return '';

      // Create repository instance to check if subdomain exists
      const repository = new UserPreferencesRepository();
      const displayName = (await repository.getSubdomainDisplayName(subdomain)) || '';
      return displayName;
    },
    enabled: shouldQuery,
  });

  return {
    subdomain,
    displayName,
    isValidSubdomain: !!displayName,
    isLoading,
    error,
    hasSubdomain: !!subdomain,
  };
};
